import { useState } from "react"
import { FaPlay } from "react-icons/fa"
import styled from "styled-components"
import { Button } from "@prosolve/common-components-ui"
import TestTaskModal from "./TestTaskModal"

const Container = styled.div``

const RowGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export default () => {
  const [isModalOpen, setIsModalOpen] = useState()

  return (
    <Container>
      <Button onClick={() => setIsModalOpen(true)}>
        <RowGroup>
          <FaPlay />
          Test Task
        </RowGroup>
      </Button>

      {isModalOpen &&
        <TestTaskModal onClose={() => setIsModalOpen()} />
      }
    </Container>
  )
}